import { Faqs as AuthorizedFaqs } from 'containers/Faqs'

export default AuthorizedFaqs
